<div ngbDropdown autoClose="outside" placement="bottom-end">
  <button
    [attr.id]="buttonId()"
    class="btn btn-primary--blue btn-md w-100"
    ngbDropdownToggle
    #buttonElement
    role="combobox"
    [attr.aria-label]="'global.address.chooseOther' | translate"
    [attr.aria-owns]="dropdownId()"
    [attr.aria-controls]="dropdownId()"
    [attr.aria-activedescendant]="dropdownId() + '_option_' + selectedOptionIndex()"
  >
    <span class="visually-hidden">{{ address() | getAddressPostCodeAndStreet }}</span>
    <span aria-hidden="true">{{ 'global.address.chooseOther' | translate }}</span>
    <i class="fas fa-chevron-down transition-all text-white ml-2" aria-hidden="true" [ngClass]="{ 'rotate-x-180': !isCollapsed() }"></i>
  </button>
  <div>
    <div
      ngbDropdownMenu
      [attr.id]="dropdownId()"
      class="dropdown-menu dropdown-menu-end"
      data-test="address-selection-dropdown"
      role="listbox"
    >
      @for (option of addressOptions(); track option) {
        @if (option?.address) {
          <button
            ngbDropdownItem
            role="option"
            [attr.id]="dropdownId() + '_option_' + $index"
            class="dropdown-item"
            (click)="onAddressSelected(option)"
            [ngClass]="{ 'dropdown-item-checked': isAddressSelected(option.address) }"
            [attr.aria-selected]="isAddressSelected(option.address) ? 'true' : 'false'"
          >
            @if (option.address.addressGroup?.groupName) {
              <div>{{ option.address.addressGroup.groupName }}</div>
            }
            <div>{{ option.address | getAddressPostCodeAndStreet }}</div>
          </button>
        }
      }
    </div>
  </div>
</div>
